import { Review } from './models/review.model';
import { List } from 'immutable';
import { ReviewRequest } from './models/review-request.model';
import { ReviewClient } from './models/review-client.model';
import { IMessageDeliveryData } from '../message-delivery/message-delivery.interface';
import { ReviewSummary } from './models/review-summary.model';
import { IReviewSettings } from './review-data.data';

export enum ActionsEnum {
  FETCH_REVIEWS = 'FETCH_REVIEWS',
  FETCH_REVIEWS_SUCCESS = 'FETCH_REVIEWS_SUCCESS',
  FETCH_REVIEWS_ERROR = 'FETCH_REVIEWS_ERROR',

  FETCH_ELIGIBLE_CLIENTS = 'FETCH_ELIGIBLE_CLIENTS',
  FETCH_ELIGIBLE_CLIENTS_SUCCESS = 'FETCH_ELIGIBLE_CLIENTS_SUCCESS',
  FETCH_ELIGIBLE_CLIENTS_ERROR = 'FETCH_ELIGIBLE_CLIENTS_ERROR',

  REQUEST_REVIEW = 'REQUEST_REVIEW',
  REQUEST_REVIEW_SUCCESS = 'REQUEST_REVIEW_SUCCESS',
  REQUEST_REVIEW_ERROR = 'REQUEST_REVIEW_ERROR',

  RESET_REQUEST_REVIEW = 'RESET_REQUEST_REVIEW',

  SEND_REQUEST_REVIEW = 'SEND_REQUEST_REVIEW',
  SEND_REQUEST_REVIEW_SUCCESS = 'SEND_REQUEST_REVIEW_SUCCESS',
  SEND_REQUEST_REVIEW_ERROR = 'SEND_REQUEST_REVIEW_ERROR',

  FETCH_REVIEW_SUMMARY = 'FETCH_REVIEW_SUMMARY',
  FETCH_REVIEW_SUMMARY_SUCCESS = 'FETCH_REVIEW_SUMMARY_SUCCESS',
  FETCH_REVIEW_SUMMARY_ERROR = 'FETCH_REVIEW_SUMMARY_ERROR',

  FETCH_REVIEW_DETAIL = 'FETCH_REVIEW_DETAIL',
  FETCH_REVIEW_DETAIL_SUCCESS = 'FETCH_REVIEW_DETAIL_SUCCESS',
  FETCH_REVIEW_DETAIL_ERROR = 'FETCH_REVIEW_DETAIL_ERROR',

  FETCH_REVIEW_SETTINGS = 'FETCH_REVIEW_SETTINGS',
  FETCH_REVIEW_SETTINGS_SUCCESS = 'FETCH_REVIEW_SETTINGS_SUCCESS',
  FETCH_REVIEW_SETTINGS_ERROR = 'FETCH_REVIEW_SETTINGS_ERROR',

  SAVE_REVIEW_SETTINGS_NETWORK = 'SAVE_REVIEW_SETTINGS_NETWORK',
  SAVE_REVIEW_SETTINGS_NETWORK_SUCCESS = 'SAVE_REVIEW_SETTINGS_NETWORK_SUCCESS',
  SAVE_REVIEW_SETTINGS_NETWORK_ERROR = 'SAVE_REVIEW_SETTINGS_NETWORK_ERROR',
}

// action payloads
export interface IFetchEligibleClientsSuccessPayload {
  clients: List<ReviewClient>;
}

export interface IFetchReviewsSuccessPayload {
  reviews: List<Review>;
}

export interface IRequestReviewPayload {
  clientId: string;
}

export interface IRequestReviewSuccessPayload {
  reviewRequest: ReviewRequest;
}

export interface ISendRequestReviewPayload {
  reviewRequestId: number;
  messageData: IMessageDeliveryData;
  clientEmail: string;
}

export interface IErrorPayload {
  error: Error;
}

export interface IFetchReviewSummarySuccessPayload {
  reviewSummary: ReviewSummary;
}

export interface IFetchReviewDetailPayload {
  reviewId: string;
}

export interface IFetchReviewDetailSuccessPayload {
  review: Review;
}

export interface IReviewSettingsPayload {
  reviewSettings: IReviewSettings;
}

// action definitions
export interface IFetchReviews {
  type: ActionsEnum.FETCH_REVIEWS;
}

export interface IFetchReviewsSuccess {
  type: ActionsEnum.FETCH_REVIEWS_SUCCESS;
  payload: IFetchReviewsSuccessPayload;
}

export interface IFetchReviewsError {
  type: ActionsEnum.FETCH_REVIEWS_ERROR;
  payload: IErrorPayload;
}

export interface IFetchEligibleClients {
  type: ActionsEnum.FETCH_ELIGIBLE_CLIENTS;
}

export interface IFetchEligibleClientsSuccess {
  type: ActionsEnum.FETCH_ELIGIBLE_CLIENTS_SUCCESS;
  payload: IFetchEligibleClientsSuccessPayload;
}

export interface IFetchEligibleClientsError {
  type: ActionsEnum.FETCH_ELIGIBLE_CLIENTS_ERROR;
  payload: IErrorPayload;
}

export interface IRequestReview {
  type: ActionsEnum.REQUEST_REVIEW;
  payload: IRequestReviewPayload;
}

export interface IRequestReviewSuccess {
  type: ActionsEnum.REQUEST_REVIEW_SUCCESS;
  payload: IRequestReviewSuccessPayload;
}

export interface IRequestReviewError {
  type: ActionsEnum.REQUEST_REVIEW_ERROR;
  payload: IErrorPayload;
}

export interface IResetRequestReview {
  type: ActionsEnum.RESET_REQUEST_REVIEW;
}

export interface ISendRequestReview {
  type: ActionsEnum.SEND_REQUEST_REVIEW;
  payload: ISendRequestReviewPayload;
}

export interface ISendRequestReviewSuccess {
  type: ActionsEnum.SEND_REQUEST_REVIEW_SUCCESS;
}

export interface ISendRequestReviewError {
  type: ActionsEnum.SEND_REQUEST_REVIEW_ERROR;
  payload: IErrorPayload;
}

export interface IFetchReviewSummary {
  type: ActionsEnum.FETCH_REVIEW_SUMMARY;
}

export interface IFetchReviewSummarySuccess {
  type: ActionsEnum.FETCH_REVIEW_SUMMARY_SUCCESS;
  payload: IFetchReviewSummarySuccessPayload;
}

export interface IFetchReviewSummaryError {
  type: ActionsEnum.FETCH_REVIEW_SUMMARY_ERROR;
  payload: IErrorPayload;
}

export interface IFetchReviewDetail {
  type: ActionsEnum.FETCH_REVIEW_DETAIL;
  payload: IFetchReviewDetailPayload;
}

export interface IFetchReviewDetailSuccess {
  type: ActionsEnum.FETCH_REVIEW_DETAIL_SUCCESS;
  payload: IFetchReviewDetailSuccessPayload;
}

export interface IFetchReviewDetailError {
  type: ActionsEnum.FETCH_REVIEW_DETAIL_ERROR;
  payload: IErrorPayload;
}

export interface IFetchReviewSettings {
  type: ActionsEnum.FETCH_REVIEW_SETTINGS;
}

export interface IFetchReviewSettingsSuccess {
  type: ActionsEnum.FETCH_REVIEW_SETTINGS_SUCCESS;
  payload: IReviewSettingsPayload;
}

export interface IFetchReviewSettingsError {
  type: ActionsEnum.FETCH_REVIEW_SETTINGS_ERROR;
  payload: IErrorPayload;
}

export interface ISaveReviewSettingsNetwork {
  type: ActionsEnum.SAVE_REVIEW_SETTINGS_NETWORK;
  payload: IReviewSettingsPayload;
}

export interface ISaveReviewSettingsNetworkSuccess {
  type: ActionsEnum.SAVE_REVIEW_SETTINGS_NETWORK_SUCCESS;
  payload: IReviewSettingsPayload;
}

export interface IISaveReviewSettingsNetworkError {
  type: ActionsEnum.SAVE_REVIEW_SETTINGS_NETWORK_ERROR;
  payload: IErrorPayload;
}

// action creators
export const fetchReviews = (): IFetchReviews => ({
  type: ActionsEnum.FETCH_REVIEWS,
});

export const fetchReviewsSuccess = (
  reviews: List<Review>
): IFetchReviewsSuccess => ({
  type: ActionsEnum.FETCH_REVIEWS_SUCCESS,
  payload: {
    reviews,
  },
});

export const fetchReviewsError = (error: Error): IFetchReviewsError => ({
  type: ActionsEnum.FETCH_REVIEWS_ERROR,
  payload: {
    error,
  },
});

export const fetchEligibleClients = (): IFetchEligibleClients => ({
  type: ActionsEnum.FETCH_ELIGIBLE_CLIENTS,
});

export const fetchEligibleClientsSuccess = (
  clients: List<ReviewClient>
): IFetchEligibleClientsSuccess => ({
  type: ActionsEnum.FETCH_ELIGIBLE_CLIENTS_SUCCESS,
  payload: {
    clients,
  },
});

export const fetchEligibleClientsError = (
  error: Error
): IFetchEligibleClientsError => ({
  type: ActionsEnum.FETCH_ELIGIBLE_CLIENTS_ERROR,
  payload: {
    error,
  },
});

export const requestReview = (clientId: string): IRequestReview => ({
  type: ActionsEnum.REQUEST_REVIEW,
  payload: {
    clientId,
  },
});

export const requestReviewSuccess = (
  reviewRequest: ReviewRequest
): IRequestReviewSuccess => ({
  type: ActionsEnum.REQUEST_REVIEW_SUCCESS,
  payload: {
    reviewRequest,
  },
});

export const requestReviewError = (error: Error): IRequestReviewError => ({
  type: ActionsEnum.REQUEST_REVIEW_ERROR,
  payload: {
    error,
  },
});

export const resetRequestReview = (): IResetRequestReview => ({
  type: ActionsEnum.RESET_REQUEST_REVIEW,
});

export const sendRequestReview = (
  reviewRequestId: number,
  messageData: IMessageDeliveryData,
  clientEmail: string
): ISendRequestReview => ({
  type: ActionsEnum.SEND_REQUEST_REVIEW,
  payload: {
    reviewRequestId,
    messageData,
    clientEmail,
  },
});

export const sendRequestReviewSuccess = (): ISendRequestReviewSuccess => ({
  type: ActionsEnum.SEND_REQUEST_REVIEW_SUCCESS,
});

export const sendRequestReviewError = (
  error: Error
): ISendRequestReviewError => ({
  type: ActionsEnum.SEND_REQUEST_REVIEW_ERROR,
  payload: {
    error,
  },
});

export const fetchReviewSummary = (): IFetchReviewSummary => ({
  type: ActionsEnum.FETCH_REVIEW_SUMMARY,
});

export const fetchReviewSummarySuccess = (
  reviewSummary: ReviewSummary
): IFetchReviewSummarySuccess => ({
  type: ActionsEnum.FETCH_REVIEW_SUMMARY_SUCCESS,
  payload: {
    reviewSummary,
  },
});

export const fetchReviewSummaryError = (
  error: Error
): IFetchReviewSummaryError => ({
  type: ActionsEnum.FETCH_REVIEW_SUMMARY_ERROR,
  payload: {
    error,
  },
});

export const fetchReviewDetail = (reviewId: string): IFetchReviewDetail => ({
  type: ActionsEnum.FETCH_REVIEW_DETAIL,
  payload: {
    reviewId,
  },
});

export const fetchReviewDetailSuccess = (
  review: Review
): IFetchReviewDetailSuccess => ({
  type: ActionsEnum.FETCH_REVIEW_DETAIL_SUCCESS,
  payload: {
    review,
  },
});

export const fetchReviewDetailError = (
  error: Error
): IFetchReviewDetailError => ({
  type: ActionsEnum.FETCH_REVIEW_DETAIL_ERROR,
  payload: {
    error,
  },
});

export const fetchReviewSettings = (): IFetchReviewSettings => ({
  type: ActionsEnum.FETCH_REVIEW_SETTINGS,
});

export const fetchReviewSettingsSuccess = (
  reviewSettings: IReviewSettings
): IFetchReviewSettingsSuccess => ({
  type: ActionsEnum.FETCH_REVIEW_SETTINGS_SUCCESS,
  payload: {
    reviewSettings,
  },
});

export const fetchReviewSettingsError = (
  error: Error
): IFetchReviewSettingsError => ({
  type: ActionsEnum.FETCH_REVIEW_SETTINGS_ERROR,
  payload: {
    error,
  },
});

export const saveReviewSettingsNetwork = (
  reviewSettings: IReviewSettings
): ISaveReviewSettingsNetwork => ({
  type: ActionsEnum.SAVE_REVIEW_SETTINGS_NETWORK,
  payload: {
    reviewSettings,
  },
});

export const saveReviewSettingsNetworkSuccess = (
  reviewSettings: IReviewSettings
): ISaveReviewSettingsNetworkSuccess => ({
  type: ActionsEnum.SAVE_REVIEW_SETTINGS_NETWORK_SUCCESS,
  payload: {
    reviewSettings,
  },
});

export const saveReviewSettingsNetworkError = (
  error: Error
): IISaveReviewSettingsNetworkError => ({
  type: ActionsEnum.SAVE_REVIEW_SETTINGS_NETWORK_ERROR,
  payload: {
    error,
  },
});
